<template>
  <div>
    <el-dialog
      top="6vh"
      width="470px"
      center
      title="状态管理"
      :visible="statusDialogVisible"
      @close="HandleCancel"
    >
      <el-form :model="statusEditData" :ref="form" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户啟用">
              <el-switch
                :disabled="
                  $store.state[this.modules].statusEditData.dispatchMode === 2
                "
                @change="HandleTriggerStatus($event, 'userEnable')"
                v-model="statusEditData.userEnable"
                :active-value="true"
                :inactive-value="false"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
              <span v-html="HandleStatus(statusEditData.userEnable)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接单频率">
              <el-switch
                @change="HandleTriggerStatus($event, 'dispatchFrequencyType')"
                v-model="statusEditData.dispatchFrequencyType"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#409EFF"
              >
              </el-switch>
              <span
                v-html="
                  HandleDispatchFrequencyTypeStatus(
                    statusEditData.dispatchFrequencyType
                  )
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="检测状态">
              <el-switch
                v-if="userInfo.userType === 'admin'"
                @change="HandleTriggerStatus($event, 'isCheckOK')"
                v-model="statusEditData.isCheckOK"
                :active-value="true"
                :inactive-value="false"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  statusEditData.isCheckOK
                    ? '忽略其余状态，直接改为 通过检测'
                    : '忽略其余状态，直接改为 未检测通过'
                "
                placement="right"
              >
                <span
                  v-if="statusEditData.isCheckOK"
                  style="font-weight: 500; color: #009100"
                  >检测通过</span
                >
                <span v-else style="font-weight: 500; color: #ff0000"
                  >未通过检测</span
                >
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          size="small"
          type="success"
          @click="HandleVaild()"
        >
          提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 启用银行卡确认 -->
    <el-dialog
      v-if="originStatusData"
      top="10vh"
      width="460px"
      center
      :title="`即将${
        statusEditData.userEnable ? '启用' : '停用'
      }${platformTypeName}「${
        originStatusData.bankCardNumber || originStatusData.id || ''
      }」`"
      :visible="warningDialog"
      @close="warningDialog = false"
    >
      <div class="wrap-notification">
        <!-- 如果是管理员 start -->
        <template
          v-if="['admin'].indexOf(userInfo.userType) !== -1 && enableCountData"
        >
          此{{ platformTypeName }}在今日已被管理员和代理启用过
          <span class="text-number-red">{{
            enableCountData.enableTimes || 0
          }}</span>
          次

          <template
            v-if="
              enableCountData.inspectLimitFrequency &&
              enableCountData.inspectLimitFrequencyMins
            "
          >
            <br />
            目前系统判定核查禁用未达冷却时间
            {{ enableCountData.inspectLimitFrequencyMins }} 分钟
          </template>

          <template v-if="enableCountData.totalCheckOrderCount">
            <br />
            查单受策略控管：<br />
            支付
            <span class="text-number-red">{{
              enableCountData.payLimitForCheckOrder || 0
            }}</span>
            笔、提现
            <span class="text-number-red">{{
              enableCountData.withdrawLimitForCheckOrder || 0
            }}</span>
            笔、合计
            <span class="text-number-red">{{
              enableCountData.totalLimitForCheckOrder || 0
            }}</span>
            笔，任一满足条件触发查单禁用
            <br />
            目前支付
            <span class="text-number-red">{{
              enableCountData.payCheckOrderCount || 0
            }}</span>
            笔、提现
            <span class="text-number-red">{{
              enableCountData.withdrawCheckOrderCount || 0
            }}</span>
            笔、合计
            <span class="text-number-red">{{
              enableCountData.totalCheckOrderCount || 0
            }}</span>
            笔
          </template>

          <br />确定要{{ enableCountData.enableTimes > 0 ? "再次" : ""
          }}{{ statusEditData.userEnable ? "启用" : "停用"
          }}{{ platformTypeName }}吗？
        </template>
        <!-- 如果是管理员 end -->

        <!-- 如果是卡主 start -->
        <template
          v-else-if="
            ['customer'].indexOf(userInfo.userType) !== -1 && enableCountData
          "
        >
          <template v-if="statusEditData.userEnable">
            <template v-if="enableCountData.useCondition">
              此{{ platformTypeName }}在
              <span class="text-number-red">{{
                enableCountData.limitHours || 0
              }}</span>
              小时内只能启用
              <span class="text-number-blue">{{
                enableCountData.canEnableTimes || 0
              }}</span>
              次，目前已启用
              <span class="text-number-red">{{
                enableCountData.enableTimes || 0
              }}</span>
              次
              <span v-if="enableCountData.limitFrequencyMins">
                <br />
                另
                <span class="text-number-red">{{
                  enableCountData.limitFrequencyMins
                }}</span>
                分钟内仅能开启一次，请勿频繁操作
              </span>
              <br />
            </template>

            <!-- 如果启用额度已满出现警告提示 -->
            <template
              v-if="
                (enableCountData.enableTimes >=
                  enableCountData.canEnableTimes ||
                  enableCountData.limitFrequency) &&
                enableCountData.useCondition
              "
              ><span style="color: #ff0000; font-weight: 600"
                >已无法再次启用{{ platformTypeName }}</span
              ></template
            >

            <!-- 否则允许继续启用提示 -->
            <template v-else
              >确定要{{
                enableCountData.useCondition && enableCountData.enableTimes > 0
                  ? "再次"
                  : ""
              }}{{ statusEditData.userEnable ? "启用" : "停用"
              }}{{ platformTypeName }}吗？
            </template>
          </template>

          <!-- 提示禁用区间 -->
          <template
            v-if="
              enableCountData.disableStartTime && enableCountData.disableEndTime
            "
          >
            <el-alert
              :closable="false"
              type="error"
              effect="dark"
              style="padding: 10px; margin: 10px 0"
            >
              <div slot="title" style="font-weight: 600">
                禁止启用区间：{{ enableCountData.disableStartTime }} 至
                {{ enableCountData.disableEndTime }}
              </div>
            </el-alert>
          </template>
        </template>
        <!-- 如果是卡主 end -->
      </div>
      <el-link @click="HandleBankCardHistory()" type="primary"
        >历史记录</el-link
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="warningDialog = false">
          取消
        </el-button>
        <el-button
          :disabled="
            ['customer'].indexOf(userInfo.userType) !== -1 &&
            enableCountData &&
            (enableCountData.enableTimes >= enableCountData.canEnableTimes ||
              enableCountData.limitFrequency) &&
            enableCountData.useCondition
          "
          size="small"
          :loading="submitLoading"
          type="success"
          @click="HandleSubmit()"
        >
          确定{{ statusEditData.userEnable ? "启用" : "停用" }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 卡主更新余额 -->
    <el-dialog
      v-if="originStatusData"
      top="10vh"
      width="280px"
      center
      title="您是否要更新余额？"
      :visible="balanceDialog"
      :show-close="false"
      :close-on-click-modal="false"
      @close="
        $emit('HandleGetList');
        HandleCancel();
      "
    >
      <div class="balance-text">
        目前余额：<span>{{
          formatNumberWithCommasAndDecimalSeparator(originStatusData.balance, 2)
        }}</span>
      </div>
      <el-input-number
        placeholder="新余额"
        style="width: 230px"
        size="small"
        v-model="balance"
        :min="0"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="
            $emit('HandleGetList');
            HandleCancel();
          "
          >不更新</el-button
        >
        <el-button
          size="small"
          :loading="balanceLoading"
          type="success"
          @click="balanceSubmit()"
        >
          更新余额
        </el-button>
      </span>
    </el-dialog>

    <!-- 银行卡启禁用历程 -->
    <EnableDialog :enable-dialog-obj.sync="enableDialogObj" />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import EnableDialog from "@/views/components/dialog/EnableDialog";
import {
  editStatus,
  updateQrcodeStatus, // for qrcode
  getAdminEnableNum,
  customerEnableNumByTactics,
  errorFeedback,
} from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["modules"],
  components: {
    EnableDialog,
  },
  data() {
    return {
      platformTypeName: null, // 银行卡 or 二维码
      submitLoading: false,
      balanceLoading: false,
      balanceDialog: false, // 更新余额弹框
      warningDialog: false, // 启用限制弹框
      balance: 0, // 新余额
      form: "form",
      originStatusData: null,
      enableCountData: null, // 启用次数
      enableDialogObj: {},
    };
  },
  watch: {
    statusDialogVisible(row) {
      this.originStatusData = this.HandleDeepCopy(
        this.$store.state[this.modules].statusEditData
      );
      if (
        this.originStatusData.platformType &&
        this.originStatusData.platformType === "qrcode"
      ) {
        this.platformTypeName = "二维码";
      } else {
        this.platformTypeName = "银行卡";
      }
      this.balance = this.originStatusData.balance;
      // 如果是管理员
      if (row && ["admin"].indexOf(this.userInfo.userType) !== -1) {
        // 取得启用次数
        getAdminEnableNum(this.originStatusData.id).then((res) => {
          this.enableCountData = res.data;
        });
        // 如果是卡主
      } else if (row && ["customer"].indexOf(this.userInfo.userType) !== -1) {
        // 取得启用次数
        customerEnableNumByTactics(this.originStatusData.id).then((res) => {
          this.enableCountData = res.data;
        });
      }
    },
  },
  computed: {
    statusEditData() {
      return this.$store.state[this.modules].statusEditData;
    },
    statusDialogVisible: {
      get() {
        return this.$store.state[this.modules].statusDialogVisible;
      },
      set(val) {
        this.HandleSetState(this.modules, "/SET_STATE", {
          statusDialogVisible: val,
        });
      },
    },
  },
  methods: {
    // 银行卡历史纪录
    HandleBankCardHistory() {
      this.enableDialogObj = {
        platformType: this.originStatusData.platformType || "",
        id: this.originStatusData.id,
        bankCardNumber: this.originStatusData.bankCardNumber,
        visible: true,
      };
    },
    HandleStatus(status) {
      let s = "启用",
        c = "009100";
      if (!status) {
        s = "停用";
        c = "ff0000";
      }
      return `<span style="font-weight: 500; color: #${c};">${s}</span>`;
    },
    HandleDispatchFrequencyTypeStatus(status) {
      let s = "单次接单",
        c = "13ce66";
      if (status === 2) {
        s = "连续接单";
        c = "409EFF";
      }
      return `<span style="font-weight: 500; color: #${c};">${s}</span>`;
    },
    HandleTriggerStatus($event, key) {
      this.statusEditData[key] = $event;
    },
    HandleCancel() {
      this.$refs[this.form].resetFields();
      this.balance = 0;
      this.enableCountData = null;
      this.originStatusData = null;
      this.balanceDialog = false;
      this.warningDialog = false;
      this.$store.commit(`${this.modules}/SET_DEFAULT`);
      this.HandleSetState(this.modules, "/SET_STATE", {
        statusDialogVisible: false,
      });
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (!valid) return;

        if (
          // 如果有禁止启用区间，且停用 或 单纯启用，都出现弹框
          (["admin", "customer"].indexOf(this.userInfo.userType) !== -1 &&
            this.enableCountData.disableStartTime &&
            this.enableCountData.disableEndTime &&
            !this.statusEditData.userEnable) ||
          this.statusEditData.userEnable
        ) {
          this.warningDialog = true;
        } else {
          // 否则直接提交
          this.HandleSubmit();
        }
      });
    },
    // 提交更新余额
    balanceSubmit() {
      this.balanceLoading = true;
      errorFeedback({
        accId: this.originStatusData.id,
        eventType: 2,
        remark: this.balance,
      })
        .then(() => {
          this.$notify.success("操作成功，余额同步后几秒刷新才会是最新的");
          this.HandleCancel();
          this.$emit("HandleGetList");
        })
        .finally(() => {
          this.balanceLoading = false;
        });
    },
    HandleSubmit() {
      this.submitLoading = true;
      if (
        this.originStatusData.platformType &&
        this.originStatusData.platformType === "qrcode"
      ) {
        updateQrcodeStatus(this.statusEditData)
          .then((res) => {
            if (
              ["customer"].indexOf(this.userInfo.userType) !== -1 &&
              this.statusEditData.userEnable
            ) {
              this.warningDialog = false;
              this.balanceDialog = true;
            } else {
              this.HandleCancel();
              this.$emit("HandleGetList");
            }
            this.$notify.success(res.message);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } else {
        editStatus(this.statusEditData)
          .then((res) => {
            if (
              ["customer"].indexOf(this.userInfo.userType) !== -1 &&
              this.statusEditData.userEnable
            ) {
              this.warningDialog = false;
              this.balanceDialog = true;
            } else {
              this.HandleCancel();
              this.$emit("HandleGetList");
            }
            this.$notify.success(res.message);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.balance-text {
  margin-bottom: 10px;
  span {
    font-weight: 600;
    font-size: 19px;
    letter-spacing: 2px;
  }
}
.wrap-notification {
  font-size: 16px;
  line-height: 40px;
  .text-number-red {
    color: #ff0000;
    font-size: 22px;
  }
  .text-number-blue {
    color: #0000ff;
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/StatusDialog.vue